import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { IdSuiteHarnessPage, IdSuiteTestConfig, QCFlowTestRequest, QCFlowTestResult } from '../models/id-suite-test';

@Injectable({
  providedIn: 'root'
})
export class IdSuiteTestService {

  baseUrl = environment.apiEndpoint + '/idsuitetest/';

  constructor(private http: HttpClient) { }

  getConfig(): Observable<IdSuiteTestConfig> {
    return this.http.get<IdSuiteTestConfig>(this.baseUrl + 'config');
  }

  runQCFlow(request: QCFlowTestRequest): Observable<QCFlowTestResult> {
    return this.http.post<QCFlowTestResult>(this.baseUrl + 'qcflow', request);
  }

  /**
   * Loads a harness page's HTML from the app's own assets. The page is rendered through an
   * iframe `srcdoc` rather than `src`, because the hosting sends X-Frame-Options: DENY on every
   * response and would refuse to frame it by URL. A plain fetch is not affected by that header.
   */
  loadHarness(page: IdSuiteHarnessPage): Observable<string> {
    const url = new URL('assets/idsuite-test/' + page, document.baseURI).toString();
    return this.http.get(url, { responseType: 'text' });
  }
}
